export default __webpack_public_path__ + "static/media/blue-plus.8978913a.svg";